<div class="config-loading" *ngIf="!loaded">
    <div class="k-i-loading"></div>
</div>

<section class="config-section" *ngIf="loaded">
    <h3 class="config-section-title">Yield Protection</h3>

    <div class="config-setting">
        <label class="config-label">Enable</label>
        <kendo-switch [(ngModel)]="yieldProtectionEnabled"></kendo-switch>
    </div>

    <div class="config-setting">
        <label class="config-label" [class.config-label-disabled]="!yieldProtectionEnabled">Activation Days Prior</label>
        <kendo-dropdownlist class="config-control"
                            [disabled]="!yieldProtectionEnabled"
                            [data]="yieldProtectionDaysPriorData"
                            [textField]="'name'"
                            [valueField]="'id'"
                            [valuePrimitive]="true"
                            [(ngModel)]="yieldProtectionSelectedDaysPrior"></kendo-dropdownlist>
    </div>

    <div class="config-setting">
        <label class="config-label" [class.config-label-disabled]="!yieldProtectionEnabled">Services/Markets</label>
        <kendo-multiselect #rsidMultiSelect
                           class="config-control filter-drop-down"
                           [disabled]="!yieldProtectionEnabled"
                           [data]="yieldProtectionRsidData.length ? yieldProtectionRsidData : yieldProtectionRsidDataAllValues"
                           [(ngModel)]="yieldProtectionSelectedRsids"
                           [filterable]="true"
                           (filterChange)="handleFilterRSID($event)"
                           [autoClose]="false">
            <ng-template kendoMultiSelectHeaderTemplate>
                <div class="button-container">
                    <button kendoButton (click)="selectAll(rsidMultiSelect)">SELECT ALL</button>
                    <button kendoButton (click)="clearAll(rsidMultiSelect)">CLEAR ALL</button>
                </div>
            </ng-template>
        </kendo-multiselect>
        <kendo-switch class="config-inline-switch"
                      [disabled]="!yieldProtectionEnabled"
                      [onLabel]="''"
                      [offLabel]="''"
                      [(ngModel)]="yieldProtectionServicesExclusive"></kendo-switch>
        <label class="config-inline-label" [class.config-label-disabled]="!yieldProtectionEnabled">{{ yieldProtectionServicesExclusive ? 'Exclusive' : 'Inclusive' }}</label>
    </div>
</section>

<div class="config-actions" *ngIf="loaded">
    <button kendoButton [primary]="true" [disabled]="saving" (click)="onSave()">
        <span *ngIf="saving" class="k-i-loading saving-icon"></span>{{ saving ? 'Saving...' : 'Save' }}
    </button>
</div>
